let counter = 1;

export function getId() {
  return `_${counter++}`;
}
